import "trix";
import "@rails/actiontext";

import DisableFileTrix from "../controllers/disable_file_trix_controller";
import SupportTicketReplyEditor from "../controllers/support_ticket_reply_editor_controller";

Stimulus.register("disable-file-trix", DisableFileTrix);
Stimulus.register("support-ticket-reply-editor", SupportTicketReplyEditor);
